let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f2lZA")).then(() => parcelRequire('as6ve'));